import { useToken } from '@ori/auth';
import { useGetCustomerProfile } from '@ori/global-api-client-react';

export const useCustomerInitials = () => {
  const { isAnonymousUser, customerId } = useToken();
  const { data } = useGetCustomerProfile(customerId, undefined, { swr: { enabled: !isAnonymousUser } });

  if (data) {
    const { firstName, lastName } = data;

    if (lastName) {
      return `${firstName ? firstName.charAt(0) : ''}${lastName.charAt(0)}`;
    }
  }

  return undefined;
};
